import createIcon from '../../createIcon';

/**
 * @component @name SentimentNeutral
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSAxNS41SDE1VjE2LjVIOVYxNS41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE1LjUgMTFDMTYuMzI4NCAxMSAxNyAxMC4zMjg0IDE3IDkuNUMxNyA4LjY3MTU3IDE2LjMyODQgOCAxNS41IDhDMTQuNjcxNiA4IDE0IDguNjcxNTcgMTQgOS41QzE0IDEwLjMyODQgMTQuNjcxNiAxMSAxNS41IDExWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTguNSAxMUM5LjMyODQzIDExIDEwIDEwLjMyODQgMTAgOS41QzEwIDguNjcxNTcgOS4zMjg0MyA4IDguNSA4QzcuNjcxNTcgOCA3IDguNjcxNTcgNyA5LjVDNyAxMC4zMjg0IDcuNjcxNTcgMTEgOC41IDExWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTExLjk5IDJDNi40NyAyIDIgNi40OCAyIDEyQzIgMTcuNTIgNi40NyAyMiAxMS45OSAyMkMxNy41MiAyMiAyMiAxNy41MiAyMiAxMkMyMiA2LjQ4IDE3LjUyIDIgMTEuOTkgMlpNMTIgMjBDNy41OCAyMCA0IDE2LjQyIDQgMTJDNCA3LjU4IDcuNTggNCAxMiA0QzE2LjQyIDQgMjAgNy41OCAyMCAxMkMyMCAxNi40MiAxNi40MiAyMCAxMiAyMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SentimentNeutral = createIcon('SentimentNeutral', [
  ['path', { d: 'M9 15.5H15V16.5H9V15.5Z', key: '1awh0r' }],
  [
    'path',
    {
      d: 'M15.5 11C16.3284 11 17 10.3284 17 9.5C17 8.67157 16.3284 8 15.5 8C14.6716 8 14 8.67157 14 9.5C14 10.3284 14.6716 11 15.5 11Z',
      key: 'hr45rr',
    },
  ],
  [
    'path',
    {
      d: 'M8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5C7 10.3284 7.67157 11 8.5 11Z',
      key: '1i0urh',
    },
  ],
  [
    'path',
    {
      d: 'M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z',
      key: '194mw1',
    },
  ],
]);

export default SentimentNeutral;
